import MessagingActionTypes from "./messaging.types";

const INITIAL_STATE = {
  open: false,
  selectedConversationId: null,
  isSending: false,
  error: null,
  // Composer drafts keyed by conversation id, so switching conversations never
  // carries text typed for one customer into another customer's composer.
  drafts: {},
  // Text staged by pre-fill flows (payment links, CSI invites, scheduling) that
  // set the message before openChatByPhone has resolved a conversation id.
  pendingMessage: null,
  // The phone number currently being resolved to a conversation, so only the
  // ChatOpenButton for that number reflects the in-flight state (not every button).
  searchingForConversationPhone: null
};

const messagingReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case MessagingActionTypes.SET_MESSAGE: {
      const payload = action.payload;
      if (payload && typeof payload === "object" && "conversationId" in payload) {
        if (!payload.conversationId) return { ...state, pendingMessage: payload.text };
        return { ...state, drafts: { ...state.drafts, [payload.conversationId]: payload.text } };
      }
      // Legacy callers pass a plain string before a conversation is selected.
      return { ...state, pendingMessage: payload };
    }
    case MessagingActionTypes.TOGGLE_CHAT_VISIBLE:
      return {
        ...state,
        open: !state.open
      };
    case MessagingActionTypes.OPEN_CHAT_BY_PHONE:
      return {
        ...state,
        searchingForConversationPhone: action.payload?.phone_num ?? null
      };
    case MessagingActionTypes.SET_SELECTED_CONVERSATION: {
      // A pending pre-fill belongs to the conversation that openChatByPhone resolved.
      const shouldAdoptPending =
        state.searchingForConversationPhone != null && state.pendingMessage != null && action.payload;
      return {
        ...state,
        open: action.payload ? true : state.open,
        searchingForConversationPhone: null,
        selectedConversationId: action.payload,
        drafts: shouldAdoptPending ? { ...state.drafts, [action.payload]: state.pendingMessage } : state.drafts,
        pendingMessage: null
      };
    }
    case MessagingActionTypes.SEND_MESSAGE:
      return {
        ...state,
        error: null,
        isSending: true
      };
    case MessagingActionTypes.SEND_MESSAGE_SUCCESS: {
      const drafts = { ...state.drafts };
      // Resent messages are unrelated to whatever is typed in the composer.
      if (action.payload?.conversationid && !action.payload?.isResend) {
        delete drafts[action.payload.conversationid];
      }
      return {
        ...state,
        drafts,
        isSending: false
      };
    }
    case MessagingActionTypes.SEND_MESSAGE_FAILURE:
      return {
        ...state,
        error: action.payload
      };
    default:
      return state;
  }
};

export default messagingReducer;
